import React, { useState, useMemo, useCallback } from 'react'
import cashier from '@/assets/images/cashier.svg'
import mall from '@/assets/images/mall.svg'
import saltout from '@/assets/images/saltout.svg'
import { Row } from '@/components/layout/layout'
import { createUseStyles, Styles } from 'react-jss'
import PopoverConfirm from '@/components/popover-confirm/popover-confirm'
import { Goods } from '@/model/types/goods'
import { $post } from '@/api'
import $msg from '@/utils/message'
import { staffStore } from '@/store/staff'
import Auth from '@/views/main/components/auth/auth'

interface IProps {
    type: 'mall' | 'cashier'
    styles?: Styles
    goodsList: Goods[]
    onChange: () => void
}

const styles = createUseStyles({
    images: {
        width: '24px',
        height: '24px',
    },
})

export const GoodsStatus: React.FC<IProps> = props => {
    const classes = styles()
    const [visible, setVisible] = useState(false)
    const hidden = () => {
        setVisible(false)
    }

    // 微商城上架状态
    const mallStatus = props.goodsList.every(item => item.on_mall)
    const cashierStatus = props.goodsList.every(item => item.status === 0)

    // 获取icon
    const getIcon = useCallback(() => {
        if (props.type === 'mall') {
            if (mallStatus) return mall

            return saltout
        }

        if (props.type === 'cashier') {
            if (cashierStatus) return cashier

            return saltout
        }
    }, [cashierStatus, mallStatus, props.type])

    // 获取上下架状态
    const getGoodsStauts = () => {
        if (props.type === 'mall') {
            if (mallStatus) return false

            return true
        }
        if (props.type === 'cashier') {
            if (cashierStatus) return false

            return true
        }
    }

    const changeGoodsStatus = () => {
        let params = {
            goods_list: props.goodsList.map(item => item.id),
        }

        if (props.type === 'cashier') {
            Object.assign(params, {
                on_cashier: !cashierStatus,
            })
        }

        if (props.type === 'mall') {
            Object.assign(params, {
                on_mall: !mallStatus,
            })
        }
        $post({
            url: '/goods/onekeyeditgoodsonshelfstatus',
            params,
        })
            .then(() => {
                $msg('success', '操作成功')
                props.onChange()
            })
            .catch(e => {
                $msg('error', e.message)
            })
    }

    const statusContent = useMemo(
        () => (
            <Row data-align-items-center style={{ ...props.styles }} data-cursor-pointer>
                <img src={getIcon()} alt="" className={classes.images} />
                <span data-margin-left-8>{props.type === 'mall' ? '微商城' : '收银台'}</span>
            </Row>
        ),
        [classes.images, getIcon, props.styles, props.type],
    )

    return staffStore.canIUse(26) ? (
        <PopoverConfirm
            trigger="click"
            visible={visible}
            types={getGoodsStauts() ? 'success' : 'error'}
            onVisibleChange={visible => {
                setVisible(visible)
            }}
            onCancel={() => hidden()}
            onConfirm={() => {
                hidden()
                changeGoodsStatus()
            }}
            content={
                <div>
                    {getGoodsStauts() ? (
                        <div>
                            <div data-color-000 data-font-size-14>
                                确认{props.goodsList.length > 1 ? '全部' : ''}上架到
                                {props.type === 'mall' ? '微商城' : '收银台'}吗？
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div data-color-000 data-font-size-14>
                                确认{props.goodsList.length > 1 ? '全部' : ''}从
                                {props.type === 'mall' ? '微商城' : '收银台'}中下架吗？
                            </div>
                            <div data-color-999 data-font-size-12>
                                下架后商品将不可出售，原销售记录不受影响
                            </div>
                        </div>
                    )}
                </div>
            }
        >
            {statusContent}
        </PopoverConfirm>
    ) : (
        <Auth perssion={26}>{statusContent}</Auth>
    )
}
